module.exports = __webpack_public_path__ + "img/cs-baseSucc-3.3bb27725.jpg";